module.exports = __webpack_public_path__ + "img/gygqk.676dbec0.png";